import React, {useEffect} from 'react';
import TemplateInformPage from '../../../Components/TemplateInformPage';
import {Localization} from '../../../Common/Localization';
import { ReactComponent as SuccessIcon} from "../../../Resources/check-contained.svg";
import {config} from "../../../Config/Config";

const styles = {
    container: {
        display: 'flex',
        flexDirection: 'column',
        position: 'relative',
        width: '100%',
        height: '100%',
        justifyContent: 'center',
    },
    alignCenter: {
        alignSelf: 'center'
    }
};

function SuccessPage() {
    let iconStroke = config.theme.iconColor || "#02aade";
    let iconFill = config.theme.iconFill || "#e6f9ff";

    useEffect(() => {
        iconStroke = config.theme.iconColor || "#02aade";
        iconFill = config.theme.iconFill || "#e6f9ff";
    }, [ config.theme.iconColor, config.theme.iconFill]);

    return (
        config.useCustomHtml ?
            <iframe style={{width: '100%', height: 'calc(100% + 40px)'}}
                    src={process.env.PUBLIC_URL + "/CustomHtml/success.html"}></iframe> :
            <div style={{...styles.container}}>
                <div style={{...styles.alignCenter}}>
                    <SuccessIcon fill={iconFill} stroke={iconStroke}/>
                </div>
                <TemplateInformPage
                    title={Localization.SUCCESS_PAGE_TITLE}
                    text={Localization.SUCCESS_PAGE_TEXT}
                />
                <div style={{height: 50}}></div>
            </div>
    );
}

export default SuccessPage;
